module.exports = __webpack_public_path__ + "img/logo.3d0a97bb.png";